<template>
  <div class="form-columns">
    <div v-if="sideText" class="form-side-text"><div>{{ sideText }} </div></div>

    <div class="form-container" >
      <div class="header"> 
        <div class="closeButton">
          <button class="theme-close-button" @click="home">
            <font-awesome-icon icon="times" />
          </button>
        </div>

        <h2>{{$t('login')}}</h2> 
      </div>

      <div class="fieldsContainer">
        <div>
          <font-awesome-icon icon="user" class="inputImage"/>
          <input id="nameField" v-model="usernameInput" v-on:keyup.enter="signIn" type="text" :placeholder="$t('signin.username')" autofocus>
        </div>
        <div>
          <font-awesome-icon icon="lock" class="inputImage"/>
          <input v-model="passwordInput" v-on:keyup.enter="signIn" type="password" :placeholder="$t('signin.password')">
        </div>  
        <div v-if="errorMessage" class="w3-panel errorBox w3-round">
          {{ errorMessage }} 
          <font-awesome-icon icon="exclamation-circle" class="errorIcon w3-right"/>
        </div>
        <router-link to="/resend-confirmation" class="specialLink w3-right" v-if="confirmationError">{{ $t('signin.confirmationNotReceived') }}</router-link>
      </div>
      
      <div class="buttonContainer">
        <div class="link">
          <router-link to="/reset-password-request" class="specialLink">{{ $t('signin.forgotPassword') }}</router-link>
          <br/>
          <router-link to="/sign-up" class="specialLink">{{ $t('signin.createAccount') }}</router-link>
        </div>
        <div class="flex"> 
          <button :class="{'button-inactive': loggingInInProgress || !enoughUserInput, 'button-default': !loggingInInProgress && enoughUserInput}" @click="signIn">{{ $t('app.menu.login') }}</button>
        </div>
      </div>  
    </div>
    <div class="dummy-space"></div>
    <router-link to="/" class="bottomLogo"><img src="../../assets/img/CA_Logo_black.png" alt="Chess Administrator" class="logo-header"> Chess Administrator</router-link>
  </div>  
</template>

<script>
import {RestAPI} from "@aws-amplify/api-rest";

const apiName = 'api';
const path = '/Authentication/Login';

export default {
  name: 'SignIn',
  data: function () {
    return {
      confirmationError: false,
      loggingIn: false,
      usernameInput: "",
      passwordInput: "",
      errorMessage: "",
      credentials: {username: "", password: ""},
      pSideText: ""
    }
  },
  mounted() {
    switch (this.$route.query.ontheside) {
      case "confirmationawaiting":
        this.pSideText = this.$t('signin.waitingForConfirmation');
        break;
      case "passwordResetMessage":
        this.pSideText = this.$t('signin.passwordResetMessage');
        break;
      case "passwordResetMsgSent":
        this.pSideText = this.$t('signin.passwordResetMsgSent');
        break;       
      case "confirmationSucces":
        this.pSideText = this.$t('signin.confirmationSucces');
        break;       
      case "sessionTimedOut":
        this.pSideText = this.$t('signin.sessionTimedOut');
        break;       
      default:
        this.pSideText = this.$t('signin.welcome');
      }
    this.focusInput();
  },
  computed: {
    confirmation: function () {
      return (this.$route.query.confirmationawaiting == 'mail');
    },
    enoughUserInput: function () {
      return this.usernameInput != "" && this.passwordInput != "";
    },
    loggedIn: function () {
      return this.$CAUser.loggedIn();
    },
    loggingInInProgress: function () {
      return this.loggingIn;
    },
    sideText: function() {
      return this.pSideText;
    },
    username: function () {
      return this.$CAUser.userName();
    },
  },
  methods: {
    signIn() {
      this.credentials.username = this.usernameInput;
      this.credentials.password = this.passwordInput;
      let that = this;
      const myInit = { 
        body: this.credentials,
        response: false,
      };
      let completePath = path;
      this.loggingIn = true;
      RestAPI
        .post(apiName, completePath, myInit)
        .then(response => {
          //console.log(JSON.stringify(response.token));
          console.log('SignIn response token:', response.token);  
          this.$CAUser.setToken(response.token);
          console.log('Token set in $CAUser:', this.$CAUser.getToken())
          this.$CAUser.setRefreshToken(response.refreshToken);
          this.loadMe();
          console.log('Loading user data...');
          this.loggingIn = false;
          })
        .catch(error => {
          this.confirmationError = false;
          that.loggingIn = false;
          switch(error.response.data.message) {
            case "Login failed":
              this.errorMessage = this.$t("signin.loginFailed");
              break;
            case "Email confirmation needed":
              this.errorMessage = this.$t("signin.confirmationNeeded");
              this.confirmationError = true;
              break;
            default:
              this.errorMessage = error.response;
              console.log("ERROR", JSON.stringify(error));
          }
        });
    },

    loadMe() {
      /* This loads the ChessUser object of the signed in user */
      const localInit = { 
        headers: { 'Authorization': 'Bearer '+ this.$CAUser.getToken()},
        response: false, 
      };
      let that = this;
      let completePath = "/authentication/me";
      RestAPI
        .get(apiName, completePath, localInit)
        .then(response => {
          console.log("This is me: " + JSON.stringify(response));
          this.$CAUser.setChessUser(response);
          that.$router.push("/");
          })
        .catch(error => {
          if (error.status !== 404) {
            console.log("ERROR", JSON.stringify(error));
          }
        });
    },

    home() {
      this.$router.push('/')
    },

    focusInput() {
      var x = document.getElementById("nameField");
      x.focus();
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


.dummy-space {
  width: calc(50vw - 200px);
  min-width: 0;
}
.errorIcon {
  margin-top: 4px; 
}
.fieldsContainer {
  position: relative;
  display: flex;
  flex-direction: column;
  margin-bottom: 12px;
  width: 100%;
  box-sizing: border-box;
}
.header {
  font-weight: bold;
  width: 100%;
}
.link {
  margin-top: 1em;
}

/* mobile */
@media screen and (max-width: 600px) {
  .dummy-space {
    width: 0;
    display: none;
  }

  .fieldsContainer {
    width: 100%;
  }
}

/* ipad */
@media screen and (min-width: 601px) and (max-width: 1280px) {
  .dummy-space {
    width: 0;
    display: none;
  }
}


</style>
